class ColorSwatch extends HTMLElement {
  constructor() {
    super();

    this.variantId = this.dataset.variantId;
    this.container = this.closest('.card-wrapper');

    // Add hover event only
    this.addEventListener('mouseenter', this.onHoverHandler.bind(this));
  }

  onHoverHandler() {
    this.colorSwatchChange();
  }

  colorSwatchChange() {
    const image = this.container.querySelector('.card--image-animate.media img');

    if (image) {
      image.src = this.dataset.src;
      image.srcset = this.dataset.srcset;
    }

    // Toggle active state on swatches
    const swatches = this.container.querySelectorAll('.color-swatch');
    swatches.forEach((swatch) => swatch.classList.remove('is-active'));
    this.classList.add('is-active');
  }
}

customElements.define('color-swatch', ColorSwatch);
